/**
 * @author: Pawan Singh Sisodiya
 */

import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import { ShimmerTable } from "react-shimmer-effects";
import schoolApi from "../../api/schoolApi";
import ScrollLazyLoader from "../common/ScrollLazyLoader";
import InfoPill from "../InfoPill";
import Dropdown from "react-bootstrap/Dropdown";
import { SessionContext } from "../SessionProvider";

const FeeDeposite = (props) => {
  const [body, setBody] = useState([]);
  const [classRecords, setClassRecords] = useState([]);
  const navigate = useNavigate();
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);

  //search class and section in filter
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [isSectionEnabled, setIsSectionEnabled] = useState(false);
  const [filteredBody, setFilteredBody] = useState([]);
  const [optionClasses, setOptionClasses] = useState([]);
  const [optionSection, setOptionSection] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);



  useEffect(() => {
    async function init() {
      try {
        const result = await schoolApi.getActiveClassRecords();
        // const result2 = await schoolApi.fetchStudentAddmission();
        const result2 = await schoolApi.fetchStudentAddmission(selectedSessionId);

        console.log("result",result)
        console.log("result 2",result2)
       
        if (result2.success) {
          const filteredFeesDepositeRecord = result2.studentAddmision.filter((item) => item?.student_info?.session_id === selectedSessionId );

          setBody(result2?.studentAddmision);
          setFilteredBody(result2?.studentAddmision);
          
        } else {
          setBody([]);
          setFilteredBody([]);
        }

        // Dynamic Class API
        let classList = await schoolApi.getActiveClassRecords();

        if (classList?.result) {
          let ar = [];

          classList.result.forEach((item) => {
            ar.push({
              value: item.id,
              label: item.classname,
            });
          });

          setOptionClasses(ar);
        } else {
          setOptionClasses([]);
        }

        if (result.success) {
          setClassRecords(result.result);
        } else {
          setClassRecords([]);
        }
      } catch (error) {
        setBody([]);
        setClassRecords([]);
      }
    }
    init();
  }, [selectedSessionId]);
  //handle class change
  const handleClassChange = async (e) =>{
    const selectedClassValue = e.target.value;
    setSelectedClass(selectedClassValue);

    if (selectedClassValue === "") {
      setIsSectionEnabled(false);
      setSelectedSection("");
      setFilteredBody(body);
      setOptionSection([]);
    } else {
      setIsSectionEnabled(true);
      setSelectedSection("");

      try {
        // section fetch
        let sectionList =
          await schoolApi.getSectionRecordById(selectedClassValue);

        if (sectionList?.record && sectionList?.record?.length > 0) {
          let sectionOptions = sectionList.record.map((item) => ({
            value: item.name,
            label: item.name,
          }));

          setOptionSection(sectionOptions);
        } else {
          setOptionSection([]);
        }
      } catch (error) {
        setOptionSection([]);
      }

      if (body) {
        const selectedClassName =
          optionClasses.find((item) => item.value == selectedClassValue)
            ?.label || "";

        const filtered = body.filter((student) => {
          const className = student.student_info.class_name || "";
          return className === selectedClassName;
        });

        setFilteredBody(filtered);
      }
    }
    setSelectedStudents([]);
  };

  const handleSectionChange = (e) =>{
    const selectedSectionValue = e.target.value;
    setSelectedSection(selectedSectionValue);

    const selectedClassName =
      optionClasses.find((item) => item.value == selectedClass)?.label || "";

    if (selectedSectionValue === "") {
      const filtered = body.filter((student) => {
        const className = student.student_info.class_name || "";

        return (
          className.trim().toLowerCase() ===
          selectedClassName.trim().toLowerCase()
        );
      });

      setFilteredBody(filtered);
    } else {
      const filtered = body.filter((student) => {
        const className = student.student_info.class_name || "";
        const sectionName = student.student_info.section_name || "";

        return (
          className.trim().toLowerCase() ===
          selectedClassName.trim().toLowerCase() &&
          sectionName.trim().toLowerCase() ===
          selectedSectionValue.trim().toLowerCase()
        );
      });

      setFilteredBody(filtered);
    }
    setSelectedStudents([]);
  };



  const formatNumberWithCommas = (number) => {
    return number ? number.toLocaleString("en-IN") : "0";
  };

  const header = [
    {
      title: "Student Name",
      prop: "student_info.studentname",
      isFilterable: true,
      show: true,
    },
    {
      title: "Class Name",
      prop: "student_info.class_name",
      isFilterable: true,
      show: true,
    },
    {
      title: "Category",
      prop: "student_info.category",
      isFilterable: true,
      show: true,
    },
    {
      title: "Fee Type",
      prop: "student_info.fee_master_type",
      isFilterable: true,
      show: true,
    },
    {
      title: "Total Fees",
      prop: "student_info.total_fees",
      cell: (row) => formatNumberWithCommas(parseInt(row.student_info.total_fees)),

      isFilterable: true,
      show: true,
    },
    {
      title: "Total Dues",
      prop: "student_info.total_dues",
      cell: (row) => formatNumberWithCommas(parseInt(row.student_info.total_dues)),

      isFilterable: true,
      show: true,
    },
    {
      title: "Date Of Birth",
      prop: "student_info.dateofbirth",
      isFilterable: true,
      show: true,
    },
    {
      title: "Phone",
      prop: "student_info.phone",
      isFilterable: true,
      show: true,
    },
    {
      title: "Action",
      prop: "",
      isFilterable: true,
      cell: (row) => (
        <div>
          <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              Action
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleFeesClick(row)}>
                Fees
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleDepositeHistoryClick(row)}>
                Deposit History
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const labels = {
    beforeSelect: " ",
  };

  const handleFeesClick = (row) => {
    navigate("/feedepositeedit/e", { state: { row } });
  };

  const handleDepositeHistoryClick = (row) => {
    navigate("/feedepositehistory/e", { state: { row } });
  };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>

      <Row className="g-0">
        <Col lg={2} className="mx-3">
          <Link className="nav-link mx-2" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> Fees Deposit List
          </Link>
        </Col>

        <Col lg={12} className="p-lg-4">
          {body ? (
            <DatatableWrapper
              body={filteredBody}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 50,
                  options: [50, 100, 200, 500, 1000],
                },
              }}
            >
              <ScrollLazyLoader maxRows={1000} step={50} />
              <Row className="mb-4">
                <Col lg={3} className="mt-3">
                  <Filter />
                </Col>
                {/* selectclass and option */}
                <Col xs={12} lg={2} className="d-flex flex-col justify-content-end align-items-end">
                  <select
                    className="form-select"
                    value={selectedClass}
                    onChange={handleClassChange}
                    style={{ borderRadius: "5px", width: "100%" }}
                  >
                    <option value="">Select Class</option>
                    {optionClasses.map((className, index) => (
                      <option key={index} value={className.value}>{className.label}</option>
                    ))}
                  </select>
                </Col>

                <Col xs={12} lg={2} className="d-flex flex-col justify-content-end align-items-end">
                  <select
                    className="form-select"
                    value={selectedSection}
                    onChange={handleSectionChange}
                    disabled={!isSectionEnabled}
                    style={{
                      borderRadius: "5px",
                      width: "100%",
                      backgroundColor: !isSectionEnabled ? "#e9ecef" : "white",
                      cursor: !isSectionEnabled ? "not-allowed" : "pointer",
                    }}
                  >
                    <option value="">Select Section </option>
                    {optionSection.map((section, index) => (
                      <option key={index} value={section.value}>{section.label}</option>
                    ))}
                  </select>
                </Col>

                <Col lg={1} style={{ "margin-top": "-6px" }}>
                  <PaginationOptions labels={labels} />
                </Col>
                <Col lg={3}>
                  <div>
                    <InfoPill left="Total Students" right={body?.length} />
                  </div>
                </Col>
              </Row>
              <Table striped className="data-table">
                <TableHeader />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={4} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </>
  );
};

export default FeeDeposite;